import { render, staticRenderFns } from "./session_limit_editor.vue?vue&type=template&id=5b4d5776&"
import script from "./session_limit_editor.vue?vue&type=script&lang=js&"
export * from "./session_limit_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b4d5776')) {
      api.createRecord('5b4d5776', component.options)
    } else {
      api.reload('5b4d5776', component.options)
    }
    module.hot.accept("./session_limit_editor.vue?vue&type=template&id=5b4d5776&", function () {
      api.rerender('5b4d5776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/profile/session_limit_editor.vue"
export default component.exports